// InlineError — presentation primitive. Pure span; no react-bootstrap.
// Renders a small message styled with the danger token. Selector-free,
// dispatch-free.
//
// Props:
//   id:        string — for aria-describedby targeting
//   children:  node   — the error message
//   className, ...rest

function InlineError({
  id,
  children,
  className = '',
  ...rest
}) {
  if (!children) return null;

  const classes = [
    'ui-inline-error',
    className,
  ].filter(Boolean).join(' ');

  return (
    <span
      id={id}
      role="alert"
      aria-live="polite"
      className={classes}
      {...rest}
    >
      {children}
    </span>
  );
}

export default InlineError;
